import { gridDefaults } from "@serenity-is/sleekgrid";

gridDefaults.useCssVars = true;
gridDefaults.useLegacyUI = true;